import React, { useState } from 'react';
import { useTheme } from '@emotion/react';
import { useIntl } from 'react-intl';
import { LoginSignupLayout } from '@fuww/library/src/Login';
import FormSubmitConfirmation
  from '@fuww/library/src/FormSubmitConfirmation';
import Hr from '@fuww/library/src/Elements/Hr';
import PropTypes from 'prop-types';
import messages from '../../lib/messages.json';
import Disclaimer from '../LoginSignup/Disclaimer';
import MarketplaceHead from '../Products/MarketplaceHead';
import ResetPasswordForm from '../LoginSignup/ResetPasswordForm';
import HomeLink from '../HomeLink';
import LinkAndAnchor from '../LinkAndAnchor';

const ResetPassword = ({ showBreadcrumbs }) => {
  const theme = useTheme();
  const intl = useIntl();
  const [changeSuccess, setChangeSuccess] = useState(false);

  const breadcrumbs = showBreadcrumbs ? [
    <HomeLink />,
    <LinkAndAnchor
      route="reset-password"
    >
      {intl.formatMessage(messages.resetPassword)}
    </LinkAndAnchor>,
  ] : [];

  if (changeSuccess) {
    return (
      <LoginSignupLayout
        breadcrumbs={breadcrumbs}
        title={intl.formatMessage(messages['resetPassword.title'])}
        disclaimer={(<Disclaimer />)}
      >
        <MarketplaceHead
          title={intl.formatMessage(messages['resetPassword.title'])}
        />
        <FormSubmitConfirmation
          successHeadline={
        intl.formatMessage(messages['resetPassword.successHeadline'])
      }
          successMessage={
        intl.formatMessage(messages['resetPassword.successMessage'])
      }
        />
      </LoginSignupLayout>
    );
  }

  return (
    <LoginSignupLayout
      breadcrumbs={breadcrumbs}
      title={intl.formatMessage(messages['resetPassword.title'])}
      disclaimer={(<Disclaimer />)}
    >
      <MarketplaceHead
        title={intl.formatMessage(messages['resetPassword.title'])}
      />
      <ResetPasswordForm setChangeSuccess={setChangeSuccess} />
      <Hr backgroundColor={theme.colors?.blackDisabled} margin="24px 0" />
    </LoginSignupLayout>
  );
};

ResetPassword.propTypes = {
  showBreadcrumbs: PropTypes.bool,
};

ResetPassword.defaultProps = {
  showBreadcrumbs: true,
};

export default ResetPassword;
